import { appQueryClient } from "$src/application/main/queryClient";
import { projectDraft, projectOriginal } from "$src/application/projects/stores/projectStore";
import { hubStore } from "$src/application/realtime/hubStore";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import type { IProjectRepository } from "$src/domain/projects/IProjectRepository";
import { DraftIdentifier } from "$src/domain/projects/drafts/DraftIdentifier";
import type { IProjectDraftRepository } from "$src/domain/projects/drafts/IProjectDraftRepository";
import { get } from "svelte/store";
import { inject, injectable } from "tsyringe";

@injectable()
export class PublishDraft {
    
    constructor(@inject(ServiceTokens.ProjectDraftRepository) private projectDraftRepository: IProjectDraftRepository, 
                @inject(ServiceTokens.ProjectService) private projectRepository: IProjectRepository) {}

    async execute(groupStoreId: number, projectId: number): Promise<DraftIdentifier> {

        projectOriginal.set(get(projectDraft));

        var identifier = await this.projectDraftRepository.PublishDraft(groupStoreId, projectId)

        get(hubStore)?.stopEditingProject(groupStoreId, projectId);

        appQueryClient.invalidateQueries(['project', groupStoreId, projectId], { refetchActive: true });

        

        return identifier;
    }
}

export const PublishDraftToken = Symbol('PublishDraftToken');